<template>
  <div>
    <div>
      <a-table
        :data-source="table.data"
        row-key="id"
        :columns="table.columns"
        style="width: 100%"
        :scroll="{ y: 'calc(100vh - 200px)' }"
        :pagination="false"
        :loading="table.loading"
      >
        <span slot="img" slot-scope="text, record" >
           <a-avatar :size="50" shape="square"  :src="record.coverPath"/>
        </span>
        <span slot="action" slot-scope="text, record">
          <a-button type="link" @click="recommendGoods(seriesId,record.id)">推荐</a-button>
          <a-button type="link" @click="cancelRecommendGoods(seriesId,record.id)">取消推荐</a-button>
        </span>
      </a-table>
      <a-pagination
        class ="pagination-class"
        v-model="table.query.page"
        :total="table.query.total"
        show-size-changer
        :page-size="table.query.size"
        :pageSizeOptions="['20']"
        @showSizeChange="handleSizeChange"
        @change="handleSizeChange">
        <template
          slot="buildOptionText"
          slot-scope="props">
          <span>{{ props.value }}条/页</span>
        </template>
      </a-pagination>
    </div>
  </div>
</template>

<script>
import {
  _queryGoodsSeriesGoods,
  _recommendSeriesGoods,
  _cancelRecommendGoods,
} from '@/api/websiteGoodsSeriesApi';

async function getGoodsSeriesList() {
  this.table.loading = true;
  let direction = this.table.sort.order;
  if (direction) {
    direction = direction === 'ascend' ? 'ASC' : 'DESC';
  }
  const result = await _queryGoodsSeriesGoods({
    id: this.seriesId,
    page: this.table.query.page,
    size: this.table.query.size,
    sort: this.table.sort.prop,
    direction,
  });

  this.table.data = result.content;
  this.table.query.total = result.totalElements;
  this.table.loading = false;
}

function closeForm() {
  this.form.data.id = null;
  this.form.visible = false;
  this.getGoodsSeriesList();
}

function handleSizeChange(page, size) {
  this.table.query.page = page;
  this.table.query.size = size;
  this.getGoodsSeriesList();
}

function handlePageChange(val) {
  this.table.query.page = val;
  this.getGoodsSeriesList();
}

async function recommendGoods(goodsSeriesId, goodsId) {
  this.$confirm({
    title: '是否推荐？',
    content: '',
    onOk: async () => {
      await _recommendSeriesGoods(goodsSeriesId, goodsId);
      this.$message.success('推荐成功');
      this.getGoodsSeriesList();
    },
  });
}

async function cancelRecommendGoods(goodsSeriesId, goodsId) {
  this.$confirm({
    title: '是否取消推荐？',
    content: '',
    onOk: async () => {
      await _cancelRecommendGoods(goodsSeriesId, goodsId);
      this.$message.success('取消成功');
      this.getGoodsSeriesList();
    },
  });
}

const columns = [
  {
    title: '图片',
    scopedSlots: { customRender: 'img' },
  },
  {
    title: '商品名',
    dataIndex: 'name',
    scopedSlots: { customRender: 'name' },
  },
  {
    title: '是否推荐',
    dataIndex: 'isRecommend',
  },
  {
    title: '操作',
    width: 300,
    scopedSlots: { customRender: 'action' },
  },
];
export default {
  name: 'SeriesItems',
  components: {
  },
  props: {
    seriesId: String,
  },
  data() {
    return {
      form: {
        data: {
          id: null,
        },
        visible: false,
      },
      table: {
        columns,
        loading: false,
        data: [],
        query: {
          page: 1,
          size: 20,
          total: 0,
        },
        sort: {
          prop: 'isRecommend',
          order: 'descending',
        },
      },
    };
  },
  methods: {
    getGoodsSeriesList,
    closeForm,
    handleSizeChange,
    handlePageChange,
    recommendGoods,
    cancelRecommendGoods,
  },
  created() {
    this.getGoodsSeriesList();
  },
};
</script>

<style scoped>

</style>
